const state = () => ({
  productsAndServices: [],
  jurisdictions: [],
  sections: [],
  countryData: [],
  productsAndServicesData: [],
  userReportData: null,
  requirementsTree: [],
  requirementCategories: []
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  setCategoryData(state, data) {
    state[data.label] = data.data.map(obj => ({ ...obj, selectedItems: [] }));
  },
  setStepStateData(state, data) {
    state[data.label][data.data - 1].disabled =
      !state[data.label][data.data - 1].disabled;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
  setApiToken: (state, data) => {
    state.tokenData = data;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, `${this.$config.env.jsonApiURL}${url}`);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  async apiToken({ commit }, { email, password }) {
    const data = {
      email,
      password,
    };
    const body = {
      method: "POST",
      url: `${this.$config.vixioAuthURL}/authentication_token`,
      headers: {
        "Content-Type": "application/json",
      },
      progress: false,
      data,
    };

    return await this.$axios(body)
      .then((data) => data.data)
      .catch(({ response }) => {
        // console.log(response);
      });
  },
  async saveReport({ commit, state, data }, { url, token, csrf }) {
    // Kris I've been having no end of trouble with this endpoint, let's catch up and discuss
    const test = {
      bundle: "country",
      label: ["My Country Report 2"],
      field_jurisdictions: [170, 166],
      field_sections: [52722, 52723],
    };
    const body = {
      method: "POST",
      url: `${this.$config.baseURL}${url}`,
      headers: {
        "Content-Type": "application/json`",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        // "Authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjViZDg1ZmMzNjE3ZDAzMWQyNTY0ODczZTgzMDQ3N2QyMTMxZmQ0NDJkMTEwODA0ZWUwMDVlMzg3OWE5YWM0OWUxNjY0YjgwOTIxNjE3YmU5In0",
        "X-CSRToken": `${csrf}`,
      },
      test,
    };
    return await this.$axios(body)
      .then((data) => data.data)
      .catch(({ response }) => {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
